real.form = (function ($) {
    'use strict';

    const trimInputs = [
        'input[type="color"]',
        'input[type="date"]',
        'input[type="datetime"]',
        'input[type="email"]',
        'input[type="hidden"]',
        'input[type="number"]',
        'input[type="password"]',
        'input[type="range"]',
        'input[type="search"]',
        'input[type="tel"]',
        'input[type="text"]',
        'input[type="time"]',
        'input[type="url"]',
        'textarea:not(.howspace-text-editor)'
    ];

    return {

        getDataPayload: function (form) {
            const dataPayload = {};

            // Loop through all elements with name attribute.
            form.find('[name]').each(function (i, input) {
                const $input = $(input);

                if (
                    $input.data('skip-from-real-form') ||
                    $input.closest('[data-skip-from-real-form="true"]', form[0]).length > 0
                ) {
                    return true;
                }

                // Get name primarily from data-name attribute, secondarily from name attribute.
                let name = $input.data('name') || $input.attr('name');
                let setValueTo = dataPayload;

                let propertyIsArray = false;
                if (name.substring(name.length - 2) === '[]') {
                    // Name contains array notation like name="features[]".
                    propertyIsArray = true;
                    name = name.substring(0, name.length - 2);
                }

                const match = name.match(/([^\{]+)\{([^\}]+)\}/);
                if (match) {
                    // Name contains object notation like name="config{token}".
                    name = match[2];
                    if (!dataPayload[match[1]]) {
                        dataPayload[match[1]] = {};
                    }
                    setValueTo = dataPayload[match[1]];
                }

                if (propertyIsArray && !setValueTo[name]) {
                    // Initialize an empty array.
                    setValueTo[name] = [];
                }

                // Initialize value from the input value.
                let value = $input.val();

                if ($input.attr('type') === 'number' || $input.data('type') === 'number') {
                    // Input is type="number" or has data-type="number" attribute. Convert value to a number.
                    value = parseFloat(value) || 0;
                }

                if ($input.data('type') === 'boolean') {
                    // Input has data-type="boolean" attribute. Convert value to a boolean.
                    if (value === 'true' || value === '1' || value === 1 || value === 'on') {
                        value = true;
                    } else {
                        value = false;
                    }
                }

                if ($input.data('type') === 'csv') {
                    // Input has data-type="csv" attribute. Explode values by comma and trim each value.
                    value = value.split(',');
                    value = value.map(value => {
                        return value.trim();
                    });
                    value = value.filter(value => {
                        return value !== '';
                    });
                }

                if ($input.data('type') === 'date') {
                    // Input has data-type="date" attribute. Get the value from data attribute.
                    value = $input.data('value') || null;
                }

                if ($input.data('type') === 'json') {
                    // Input has data-type="json" attribute. Convert value from a JSON string.
                    value = JSON.parse(value);
                }

                // Howspace text editor
                if ($input.is('textarea.howspace-text-editor')) {
                    value = howspace.components.textEditor.getContent($input);
                    if (propertyIsArray) {
                        setValueTo[name].push(value);
                    } else {
                        setValueTo[name] = value;
                    }
                }

                // Howspace simple text editor
                if ($input.is('.howspace-simple-text-editor')) {
                    value = howspace.components.simpleTextEditor.getContent($input);
                    if (propertyIsArray) {
                        setValueTo[name].push(value);
                    } else {
                        setValueTo[name] = value;
                    }
                }

                // Radio
                if ($input.is('input[type="radio"]:checked')) {
                    const valueIsArray = Array.isArray(value);
                    const valueIsObject = typeof value === 'object' && !valueIsArray;
                    const propertyIsObject = typeof setValueTo[name] === 'object' && !Array.isArray(setValueTo[name]);

                    if (propertyIsArray) {
                        if (valueIsArray) {
                            value.forEach((val) => {
                                setValueTo[name].push(val);
                            });
                        } else {
                            setValueTo[name].push(value);
                        }
                    } else if (valueIsObject && propertyIsObject) {
                        real.loop(value, (loopValue, loopKey) => {
                            setValueTo[name][loopKey] = loopValue;
                        });
                    } else {
                        setValueTo[name] = value;
                    }
                    return true;
                }

                // Checkbox
                if ($input.is('input[type="checkbox"]')) {
                    if (propertyIsArray) {
                        if ($input.data('unchecked-value') && !$input.prop('checked')) {
                            setValueTo[name].push($input.data('unchecked-value'));
                        } else if ($input.prop('checked') && $input.attr('value')) {
                            setValueTo[name].push(value);
                        }
                    } else if ($input.data('unchecked-value') && !$input.prop('checked')) {
                        setValueTo[name] = $input.data('unchecked-value');
                    } else if ($input.attr('value')) {
                        if ($input.prop('checked')) {
                            setValueTo[name] = value;
                        }
                    } else {
                        setValueTo[name] = $input.prop('checked');
                    }
                    return true;
                }

                // Select
                if ($input.is('select')) {
                    if (propertyIsArray) {
                        setValueTo[name].push(value);
                    } else {
                        setValueTo[name] = value;
                    }
                    return true;
                }

                // Any input which value should be trimmed
                if ($input.is(trimInputs.join(', '))) {
                    if (value !== undefined && value !== null && typeof value.trim === 'function') {
                        value = value.trim();
                    }

                    if (propertyIsArray) {
                        setValueTo[name].push(value);
                    } else {
                        setValueTo[name] = value;
                    }
                    return true;
                }
            });

            return dataPayload;
        }

    };
})(jQuery);
